import { render, staticRenderFns } from "./image-editor-controller.vue?vue&type=template&id=2f212853&scoped=true&"
import script from "./image-editor-controller.vue?vue&type=script&lang=js&"
export * from "./image-editor-controller.vue?vue&type=script&lang=js&"
import style0 from "./image-editor-controller.vue?vue&type=style&index=0&id=2f212853&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f212853",
  null
  
)

export default component.exports